"use strict";
/**
 * Weekly Report V2 Constants
 *
 * Shared constants for the V2 weekly report pipeline.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPARENT_AGE_FLOOR = exports.APPARENT_AGE_CAP_OFFSET_LOWER = exports.APPARENT_AGE_CAP_OFFSET_UPPER = exports.BASELINE_CONFIDENCE_THRESHOLD_FULL = exports.SIGNAL_LOOKBACK_MONTHS = exports.DEFAULT_ESTABLISHED_WEEKS = exports.DEFAULT_TOO_EARLY_WEEKS = exports.MIN_SCAN_DAYS_FOR_FIRST_REPORT = void 0;
// ============================================================================
// REPORT GENERATION
// ============================================================================
/** Minimum unique scan days required before a first report can be generated */
exports.MIN_SCAN_DAYS_FOR_FIRST_REPORT = 3;
// ============================================================================
// EVALUATION TIMELINES
// ============================================================================
/** Default too-early window in weeks when no MECHANISM_MATRIX entry exists */
exports.DEFAULT_TOO_EARLY_WEEKS = 4;
/** Default established window in weeks when no MECHANISM_MATRIX entry exists */
exports.DEFAULT_ESTABLISHED_WEEKS = 12;
/** Lookback window in months for MCID alerts and acute signal queries.
 *  Change events are kept unbounded (low volume, full history needed). */
exports.SIGNAL_LOOKBACK_MONTHS = 6;
// ============================================================================
// BASELINE QUALITY THRESHOLDS
// ============================================================================
/**
 * Confidence threshold for a "full" quality baseline.
 *
 * The EMA confidence (0..1) already encodes data reliability — recency,
 * effective sample size (nEffRecent), analysis quality, etc. We use the
 * average confidence across baseline metrics as the quality proxy:
 *   >= threshold → FULL (reliable reference point)
 *   <  threshold → PARTIAL (reference exists but low confidence)
 *   no metrics   → NONE
 */
exports.BASELINE_CONFIDENCE_THRESHOLD_FULL = 0.5;
// ============================================================================
// APPARENT AGE DISPLAY BOUNDS
// ============================================================================
/** Maximum years apparent age can exceed the user's biological age */
exports.APPARENT_AGE_CAP_OFFSET_UPPER = 4;
/** Maximum years apparent age can be below the user's biological age */
exports.APPARENT_AGE_CAP_OFFSET_LOWER = 6;
/** Absolute minimum apparent age — never display below this value */
exports.APPARENT_AGE_FLOOR = 18;
//# sourceMappingURL=constants.js.map